import React from "react";
import { FaLinkedinIn } from "react-icons/fa";
import "./footer.scss";
import { Col, Container, Row } from "react-bootstrap";
import Logo from "../../../../../assets/website-images/utrust-logo.png";
import { GoArrowRight } from "react-icons/go";
import { AiFillInstagram } from "react-icons/ai";
import { BsTwitterX } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer({ footerRef }) {
  const { t } = useTranslation();
  return (
    <div className="footer" ref={footerRef}>
      <div className={"row-1"}>
        <Container>
          <Row>
            <Col xs={6} sm={6} md={4} lg={4} className={"d-none d-lg-block"}>
              <ul className={"f-row"}>
                <li>
                  <Link to="/">{t("menu.home")}</Link>
                </li>
                <li>
                  <Link to="/product">{t("menu.products")}</Link>
                </li>
                <li>
                  <Link to="/services">{t("menu.services")}</Link>
                </li>
                <li>
                  <Link to="/clients">{t("menu.clients")}</Link>
                </li>
                <li>
                  <Link to="/contact">{t("menu.contact")}</Link>
                </li>
              </ul>
            </Col>
            {/* <Col sm={0} lg={1} /> */}
            <Col sm={6} md={4} lg={4} className={"text-center"}>
              <img className={"mb-4"} src={Logo} />
            </Col>
            {/* <Col sm={6} md={4} lg={1}/> */}
            <Col lg={4}>
              <h3 className="newsletter-heading"> {t("footer.connected")}</h3>
              <form>
                <div className="email-input">
                  <input
                    type="email"
                    name="email"
                    id=""
                    placeholder="Enter email"
                  />
                  <span className={"arrow-right-icon"}>
                    <GoArrowRight />
                  </span>
                </div>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={"row02"}>
        <Container fluid className={""}>
          <Row>
            <Col>
              <div className="footer-info">
                <p>
                  <span className="teal">{t("address")}</span>:{" "}
                  {t("address_text")}
                </p>
                <div>
                  <p>
                    <span className="teal">{t("phone")}</span>:{" "}
                    <span dir={"ltr"}>+966112699918</span>
                  </p>
                  <p className="teal">{t("email_address")}: info@utrust.sa</p>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="footer-copyright">
                {/*<p>Copyright &copy; 2025 <span className='teal'>uTrust</span>. All Rights Reserved</p>*/}
                <p>{t("copyright", { year: new Date().getFullYear() })}</p>
                <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                  {/*<span><FaFacebookF /></span>*/}
                  <span>
                    <a
                      className={"text-white"}
                      href="https://www.instagram.com/utrustsa?igsh=MTQ0d2N4Nms1NTdoNg=="
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <AiFillInstagram className="text-pink-500 text-3xl" />
                    </a>
                  </span>
                  <span>
                    <a
                      className={"text-white"}
                      href="https://x.com/utrustsa?s=21"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <BsTwitterX className="text-blue-500 text-3xl" />
                    </a>
                  </span>
                  <span>
                    <a
                      className={"text-white"}
                      href="https://www.linkedin.com/company/utrustsa/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedinIn className="text-blue-700 text-3xl" />
                    </a>
                  </span>
                </div>
                <div className="terms">
                  <ul>
                    <li>
                      <Link to="/terms-and-conditions">{t("terms")}</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">{t("policy")}</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
